<template>
  <card class="login-card form-card">
    <template slot="header">
      <div class="form-title login-title">{{ title }}</div>
      <div class="error" v-if="error != ''">{{ error }}</div>
    </template>
    <template>
      <div class="row justify-content-center">
        <div class="col">
          <fg-input type="text"
                    label="Username or Email"
                    v-model="username_or_email"
                    @keyup.enter.native="signIn">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <fg-input type="password"
                    label="Password"
                    v-model="password"
                    @keyup.enter.native="signIn">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <button type="button" class="btn-basic forgot-password" @click="resetPassword">
          {{ reset_password }}
        </button>
      </div>
      <div class="row justify-content-center">
        <default-button :buttonText="sign_in" :processing-click="attempting_sign_in" v-on:onButtonClicked="signIn" />
      </div>
    </template>
  </card>
</template>
  
<script>
  import axios from 'axios'
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'

  export default {
    components: {
      Card,
      DefaultButton,
    },
    data: function () {
      return {
        title: "Merchant Login",
        username_or_email: "",
        password: "",
        reset_password: "forgot password?",
        sign_in: "SIGN IN",
        attempting_sign_in: false,
        error: "",
      }
    },
    methods: {
      signIn() {
        if (!this.attempting_sign_in) {
          // this.error = "";
          this.attempting_sign_in = true;

          const headers = {
            headers: {
              'Content-Type': 'application/json',
            }
          }

          const payload = JSON.stringify({
            username_or_email: this.username_or_email,
            password: this.password,
          })

          axios.post(this.$store.state.jwt.endpoints.obtainJWT, payload, headers)
            .then((response)=>{
              this.$store.dispatch('setToken', response.data.token);
              this.$router.push('/');
            })
            .catch((error)=>{
              this.error = 'Username or password incorrect';
              this.attempting_sign_in = false;
            })
        }
      },
      resetPassword() {
        this.$router.push('password_reset')
      },
    },
  }
</script>
